module.exports = __webpack_public_path__ + "static/media/image1.9143b5a8.webp";